export default __webpack_public_path__ + "static/media/tone440.646eaadf.mp3";